import httpClient from '../../../shared/services/http/http-client';

export default class PublicReportsService {
  http;

  constructor() {
    this.http = httpClient
  }

  async get(reportType: string, reportPeriodId: string): Promise<any> {
    return this.http.get(`public-report/webpage/${reportType}/${reportPeriodId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }
}